"use client";

import React from "react";
import { ArrowRight, Sparkles } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Ready() {
  const {
    ref: headerRef,
    isVisible: isHeaderVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: ctaRef,
    isVisible: isCtaVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="ready" className="relative overflow-hidden bg-card py-32 md:py-48 flex items-center justify-center border-y border-border/30">
            {}
            <div className="absolute inset-0 pointer-events-none">
                <div className="absolute inset-0 bg-[linear-gradient(to_right,var(--color-primary)_1px,transparent_1px),linear-gradient(to_bottom,var(--color-primary)_1px,transparent_1px)] bg-[size:3rem_3rem] [mask-image:radial-gradient(ellipse_70%_70%_at_50%_50%,#000_10%,transparent_100%)] opacity-[0.04] animate-[pulse_4s_ease-in-out_infinite]" />
            </div>

            {}
            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-primary/10 blur-[150px] rounded-full pointer-events-none" />

            <div className="relative z-10 container mx-auto px-4 md:px-6 flex flex-col items-center text-center">
                <div ref={headerRef} className={`transition-all duration-1000 transform ${isHeaderVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-12'}`}>
                    <h2 className="text-5xl font-black uppercase tracking-tighter max-w-6xl mx-auto leading-[0.85] !text-[hsl(214,57%,21%)] sm:text-6xl md:text-8xl lg:text-9xl">
                        Ready to find <br className="hidden md:block" /> your space?
                    </h2>
                </div>

                <div ref={ctaRef} className={`mt-16 md:mt-24 flex flex-col items-center transition-all duration-1000 delay-200 transform ${isCtaVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-12'}`}>
                    <Link to="/ProcessPage" className="group relative inline-block">
                        {}
                        <div className="absolute -inset-3 bg-primary rounded-xl blur-2xl opacity-40 group-hover:opacity-70 transition duration-500 animate-[pulse_3s_ease-in-out_infinite]" />

                        {}
                        <Button size="lg" className="inline-flex items-center justify-center gap-2 whitespace-nowrap [&_svg]:pointer-events-none [&_svg:not([class*='size-'])]:size-4 shrink-0 [&_svg]:shrink-0 outline-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 aria-invalid:border-destructive h-10 has-[>svg]:px-4 relative bg-secondary text-xl px-12 py-8 font-black uppercase tracking-widest rounded-md border-2 border-secondary/50 shadow-2xl transition-all duration-300 group-hover:scale-105 !text-[hsl(214,57%,21%)] disabled:pointer-events-none disabled:opacity-50 dark:aria-invalid:ring-destructive/40 hover:bg-secondary/90 md:text-2xl lg:text-3xl md:px-16 md:py-12">Talk to pocketpal<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="lucide lucide-arrow-right ml-4 size-6 md:size-8 transition-transform duration-300 group-hover:translate-x-3" aria-hidden="true" data-ast-id="f:/src/pages/Home/sections/Ready.tsx|sig:xx8uo9" data-ast-start="2830" data-ast-end="2938"><path d="M5 12h14"></path><path d="m12 5 7 7-7 7"></path></svg></Button>
                    </Link>

                    {}
                    <div className="mt-10 flex items-center gap-3">
                        <Sparkles className="size-4 text-primary animate-pulse" />
                        <span className="text-primary text-xs md:text-sm font-bold tracking-[0.4em] uppercase">
                            Free Always
                        </span>
                        <Sparkles className="size-4 text-primary animate-pulse" />
                    </div>
                </div>
            </div>
        </section>;
}